var map = {
	"./aliexpress.png": "0b5d",
	"./amazon.png": "45cc",
	"./bigcommerce.png": "246a",
	"./cmoffer.png": "db73",
	"./ebay.png": "3791",
	"./etsy.png": "a336",
	"./magento.png": "7c11",
	"./shopee.png": "93dd",
	"./shopify.png": "0c89",
	"./shoplazza.png": "d496",
	"./shopline.png": "fc13",
	"./woocommerce.png": "414d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a372";